import { useFieldLabel } from './useFieldLabel';

export interface MenuLabels {
  dashboard: string;
  home: string;
  feed: string;
  posts: string;
  list: string;
  privateList: string;
  messages: string;
  profile: string;
  groups: string;
  notifications: string;
  settings: string;
  search: string;
  connections: string;
  myNetworkSection: string;
  collaborationSection: string;
  knowledgeSharingSection: string;
  availabilitySection: string;
  managerCenterSection: string;
  aiDiscoverySection: string;
  informationSection: string;
  availability: string;
  explorePeople: string;
  availabilityApprovals: string;
  skillApprovals: string;
  reports: string;
  workforceIntelligence: string;
  askIsentryxAi: string;
  about: string;
  myFeedback: string;
  wishlist: string;
  viewPost: string;
  viewPosts: string;
  createPost: string;
  themeSettings: string;
  changePassword: string;
  logout: string;
  account: string;
  connectingInformation: string;
  accountLogin: string;
  resources: string;
  onlineSafety: string;
  childSafety: string;
  helpCenter: string;
  termsConditions: string;
  privacyPolicy: string;
}

export const useMenuLabels = (): MenuLabels => ({
  
  dashboard: useFieldLabel('MENU_DASHBOARD', 'Dashboard'),
  home: useFieldLabel('MENU_HOME', 'Home'),
  feed: useFieldLabel('MENU_FEED', 'Feed'),
  posts: useFieldLabel('MENU_POSTS', 'Posts'),
  list: useFieldLabel('MENU_LIST', 'Lists',true),
  privateList: useFieldLabel('MENU_PRIVATE_LIST', 'Private List',true),
  messages: useFieldLabel('MENU_MESSAGES', 'Messages',true),
  profile: useFieldLabel('MENU_PROFILE', 'My Profile'),
  groups: useFieldLabel('MENU_GROUPS', 'Communities'),
  notifications: useFieldLabel('MENU_NOTIFICATIONS', 'Notifications',true),
  settings: useFieldLabel('MENU_SETTINGS', 'Settings'),
  search: useFieldLabel('MENU_SEARCH', 'Search'),
  connections: useFieldLabel('MENU_CONNECTIONS', 'My Network'),
  myNetworkSection: useFieldLabel('MENU_MYNETWORK', 'My Network',true),
  collaborationSection: useFieldLabel('MENU_COLLABORATION', 'Collaboration',true),
  knowledgeSharingSection: useFieldLabel('MENU_KNOWLEGE_SHARING', 'Knowledge Sharing',true),
  availabilitySection: useFieldLabel('MENU_AVAILABILITY', 'Availability',true),
  managerCenterSection: useFieldLabel('MENU_MANAGER_CENTER', 'Manager Center',true),
  aiDiscoverySection: useFieldLabel('MENU_SECTION_AI_DISCOVERY', 'AI & Discovery'),
  informationSection: useFieldLabel('MENU_INFORMATION', 'Information',true),
  availability: useFieldLabel('MENU_AVAILABILITY', 'My Availability'),
  explorePeople: useFieldLabel('MENU_EXPLORE_PEOPLE', 'Explore People',true),
  availabilityApprovals: useFieldLabel('MENU_AVAILABILITY_APPROVALS', 'Availability Approvals'),
  skillApprovals: useFieldLabel('MENU_SKILL_APPROVALS', 'Skill Approvals'),
  reports: useFieldLabel('MENU_REPORTS', 'Reports',true),
  workforceIntelligence: useFieldLabel('MENU_WORKFORCE_INTELLIGENCE', 'Workforce Intelligence'),
  askIsentryxAi: useFieldLabel('MENU_ASK_ISENTRYX_AI', 'Talent & Expert Finder'),
  about: useFieldLabel('MENU_ABOUT', 'About'),
  myFeedback: useFieldLabel('MENU_MY_FEEDBACK', 'My Feedback'),
  wishlist: useFieldLabel('MENU_WISHLIST', 'Wishlist'),
viewPost: useFieldLabel('MENU_VIEW_POST', 'View Post'),
  viewPosts: useFieldLabel('MENU_VIEW_POSTS', 'View Posts',true),
  createPost: useFieldLabel('MENU_CREATE_POST', 'Create Post'),
  themeSettings: useFieldLabel('MENU_THEME_SETTINGS', 'Theme Settings',true),
  changePassword: useFieldLabel('MENU_CHANGE_PASSWORD', 'Change Password'),
  logout: useFieldLabel('MENU_LOGOUT', 'Logout'),
  account: useFieldLabel('MENU_ACCOUNT', 'Account'),
  connectingInformation: useFieldLabel('MENU_CONNECTING_INFORMATION', 'Connecting Information'),
  accountLogin: useFieldLabel('MENU_ACCOUNT_LOGIN', 'Account Login'),
  resources: useFieldLabel('MENU_RESOURCES', 'Resources'),
  onlineSafety: useFieldLabel('MENU_ONLINE_SAFETY', 'Online Safety'),
  childSafety: useFieldLabel('MENU_CHILD_SAFETY', 'Child Safety'),
  helpCenter: useFieldLabel('MENU_HELP_CENTER', 'Help Center'),
  termsConditions: useFieldLabel('MENU_TERMS_CONDITIONS', 'Terms & Conditions'),
  privacyPolicy: useFieldLabel('MENU_PRIVACY_POLICY', 'Privacy Policy'),
});
